import { service } from ".";
import { SelfRegisterParams } from "../types";

export const selfRegister = (params: SelfRegisterParams) => service('/api/v1/accounts/self-register', {method: 'POST', data: params});

export const selfRegisterGetResendToken = (params: {newEmail?: string, registeredEmail: string}) => service('/api/v1/accounts/self-register-resend-token', {method: 'GET', params});

export const selfRegisterPostResendToken = (params: {newEmail?: string, registeredEmail: string}) => service('/api/v1/accounts/self-register-resend-token', {method: 'POST', params});

export const selfRegisterGetValidateAccount = (params: {token: string}) => service('/api/v1/accounts/self-register-validate-token', {method: 'GET', params});

export const selfRegisterPostValidateAccount = (params: {token: string}) => service('/api/v1/accounts/self-register-validate-token', {method: 'POST', params});
